import { render, staticRenderFns } from "./WebProducto.vue?vue&type=template&id=1ea63597&"
import script from "./WebProducto.vue?vue&type=script&lang=js&"
export * from "./WebProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports